import React from "react";
import { Outlet } from "react-router-dom";
import { connect } from "react-redux";

const OpenRoute = (props: any) => {
  const { user } = props;
  
  if (user) {
    // If user is logged in, sign them out and proceed to the route
    props.onSignOut();
  }
  
  // Just render the child routes using Outlet
  return <Outlet />;
};

const mapStateToProps = (state: any) => {
  return {
    user: state?.auth?.currentUser || null,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    onSignOut: () => dispatch({ type: "LOGOUT" }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OpenRoute);